<template>
  <div class="auth-page">
    <div class="container page">
      <div class="row">
        <div class="col-md-6 offset-md-3 col-xs-12">
          <h1 class="text-xs-center">Resend Confirm Email</h1>
          <p class="text-xs-center">
            <router-link :to="{ name: 'login' }">
              Return to Login
            </router-link>
          </p>
          <ul v-if="errors && JSON.stringify(errors) !== JSON.stringify({})" class="error-messages">
            <li>{{errors}}</li>
          </ul>
          <form v-on:submit.prevent="onSubmit(email)">
            <fieldset class="form-group">
              <input
                class="form-control form-control-lg"
                type="text"
                v-model="email"
                placeholder="Email"
              />
            </fieldset>
            <button class="btn btn-lg btn-primary pull-xs-right">
              Send Email
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { RESENDEMAIL } from "@/store/actions.type";

export default {
  name: "RwvLogin",
  data() {
    return {
      email: null
    };
  },
  methods: {
    onSubmit(email) {
      this.$store
        .dispatch(RESENDEMAIL, { Username: email })
        .then(() => this.$router.push({ name: "login" }));
    }
  },
  computed: {
    ...mapState({
      errors: state => state.auth.errors
    })
  }
};
</script>
